// Shared compact preview limit for virtual-scroll-safe Leads UI.
export const MAX_VIEW = 2;
